import { Component, OnInit } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { LoaderService, RestService, UniversalCreateComponent, UniversalCrudComponent, UniversalDetailsComponent } from "@stdoutsrl/design-kit";
import { api, environment } from "../environments/environment";
import { Router } from "@angular/router";
import * as universalJson from './models/universal-json';
import { mockData } from "../mockData";
import { ShipsComponent } from "./pages/ships/ships.component";
import { BookingComponent } from "./pages/booking/booking.component";
import { ContactsComponent } from "./pages/contacts/contacts.component";
import { ProfileComponent } from "./pages/profile/profile.component";
import { WhoComponent } from "./pages/who/who.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private transloco: TranslocoService,private rest:RestService,private loader:LoaderService,private router:Router) {}

  isUniversalLoaded = false

  ngOnInit(): void {
    this.rest.setEnviroment(environment,api)
    if(localStorage.getItem('token')){
      this.rest.setToken(localStorage.getItem('token') ?? '')
    }
    let language: any = JSON.parse(localStorage.getItem("language") ?? "null");
    let html = document.getElementById("html");
    if (language?.value) {
      this.transloco.setActiveLang(language?.value ? language?.value : "it");
      if (html && language) {
        html.lang = language?.value;
      }
    } else {
      let localLanguage = { value: "it", label: "Italiano" };
      this.transloco.setActiveLang("it");
      localStorage.setItem("language", JSON.stringify(localLanguage));
    }
    this.getAccessibility();
    this.changeColors();
    this.invert();
    this.getMyUniversal()
  }

  getMyUniversal() {
    // this.loader.on()
    // this.rest.get('/universal/' + window.location.host).subscribe({
    //   next:(value)=> {
    //     this.loader.off(true)
    //     this.remakeRoutes(value)
    //   },
    //   error:(value)=> {
    //     this.loader.off(true)
    //     this.remakeRoutes(universalJson)
    //   },
    // })
    this.remakeRoutes(universalJson)
  
  }

  remakeRoutes(value: any) {
    let myLang = localStorage.getItem('language') ? JSON.parse(localStorage.getItem('language') ?? '').value : 'it'
    this.transloco.setTranslation({
      dynamicKey: 'Valore dinamico'
    }
      ,
      myLang,
      { merge: true }
    )

    this.transloco.selectTranslateObject("routes").subscribe((route) => {
      let newRoutes = this.router.config

      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          if (value[key].route) {
            // newRoutes[1].children?.push(
            //   {
            //     path: route[value[key].route]?.path,
            //     title: route[value[key].route]?.menu,
            //     component: (value[key].showSideNav == false || value[key].showSideNav == true) ? UniversalCrudComponent : UniversalDetailsComponent,
            //     data: { ...value[value[key].route], mockData: mockData }
            //   }
            // )
            // console.log({
            //     path: route[value[key].route]?.path,
            //     title: route[value[key].route]?.menu,
            //     component: (value[key].showSideNav == false || value[key].showSideNav == true) ? UniversalCrudComponent : UniversalDetailsComponent,
            //     data: { ...value[value[key].route], mockData: mockData }
            //   });
            
          }
        }
      }
      if (route.ships) {
        newRoutes[0].children?.push(
          {
            path: route.ships.path,
            title: route.ships.menu,
            component: ShipsComponent,
          }
        )
      }
      if (route.booking) {
        newRoutes[0].children?.push(
          {
            path: route.booking.path,
            title: route.booking.menu,
            component: BookingComponent,
          }
        )
        newRoutes[0].children?.push(
          {
            redirectTo: route.booking.path,
            path:''
          }
        )
      }
      if (route.contacts) {
        newRoutes[0].children?.push(
          {
            path: route.contacts.path,
            title: route.contacts.menu,
            component: ContactsComponent,
          }
        )
      }
      if (route.profile) {
        newRoutes[0].children?.push(
          {
            path: route.profile.path,
            title: route.profile.menu,
            component: ProfileComponent,
          }
        )
      }
      if (route.who) {
        newRoutes[0].children?.push(
          {
            path: route.who.path,
            title: route.who.menu,
            component: WhoComponent,
          }
        )
      }
      if (route.privacy) {
        console.log({
            path: route.privacy.path,
            title: route.privacy.menu,
            component: PrivacyComponent,
          });
        
        newRoutes[0].children?.push(
          {
            path: route.privacy.path,
            title: route.privacy.menu,
            component: PrivacyComponent,
          }
        )
      }

      this.isUniversalLoaded = true
      this.router.resetConfig(newRoutes)
      this.router.navigate([window.location.pathname])
    });
  }

  changeColors() {
    let body = document.getElementById("body");

    if (body) {
      body.style.filter = `contrast(${localStorage.getItem(
        "colorAccessibility"
      )}%)`;
    }
  }

  invert() {
    let containerBody = document.getElementById("container-body");
    if (containerBody) {
      containerBody.style.filter = `${
        localStorage.getItem("isInverted") == "true"
          ? "invert(100%)"
          : "invert(0)"
      }`;
    }
  }

  getAccessibility() {
    let accessibility: any = localStorage.getItem("accessibility");
    if (accessibility) {
      accessibility = JSON.parse(accessibility);
      document.body.style.setProperty(
        "--small",
        12 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--normal",
        14 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--medium",
        16 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--large",
        18 * accessibility?.value + "px"
      );
      document.body.style.setProperty(
        "--title",
        24 * accessibility?.value + "px"
      );
    } else {
      document.body.style.setProperty("--small", 12 + "px");
      document.body.style.setProperty("--normal", 14 + "px");
      document.body.style.setProperty("--medium", 16 + "px");
      document.body.style.setProperty("--large", 18 + "px");
      document.body.style.setProperty("--title", 24 + "px");
    }
  }
  getTheme() {
    let theme = localStorage.getItem("theme");
    switch (theme) {
      case "base":
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");
        break;
      case "dark":
        document.body.style.setProperty("--primary", "#102A35");
        document.body.style.setProperty("--secondary", "#47AD9F");
        document.body.style.setProperty("--tertiary", "#111111");
        document.body.style.setProperty("--quaternary", "#FFFFFF");
        break;
      default:
        document.body.style.setProperty("--primary", "#47AD9F");
        document.body.style.setProperty("--secondary", "#102A35");
        document.body.style.setProperty("--tertiary", "#FFFFFF");
        document.body.style.setProperty("--quaternary", "#111111");

        break;
    }
  }
}
